<div
  class="section"
  [class.dark]="color"
  [class.header-out-of-view]="headerOutOfView"
  [class.scrolled]="scrolled"
  *onlyForScreens="['desktop']"
>
  <app-header [bigish]="true" class="static">
    <a class="logo-el" [routerLink]="'/'">
      <img src="/assets/picflow-icon.svg" alt="" width="32" height="32" />
      <span>Picflow</span>
    </a>
    <div class="spacer"></div>
    <app-website-desktop-menu *ngIf="!hideNav"></app-website-desktop-menu>
    <div class="spacer"></div>
    <div class="header-buttons small-spacing" *ngIf="!headerOutOfView">
      <ng-container *ngTemplateOutlet="ctaButtons"></ng-container>
    </div>
  </app-header>
</div>

<div *onlyForScreens="['desktop']">
  <div *ngIf="headerOutOfView" class="fixed-desktop-header" [@fixedDesktopHeader]>
    <app-header [bigish]="true">
      <a class="logo-el" [routerLink]="'/'">
        <img src="/assets/picflow-icon.svg" alt="" width="32" height="32" />
        <span>Picflow</span>
      </a>
      <div class="spacer"></div>
      <app-website-desktop-menu *ngIf="!hideNav"></app-website-desktop-menu>
      <div class="spacer"></div>
      <div class="header-buttons small-spacing">
        <ng-container *ngTemplateOutlet="ctaButtons"></ng-container>
      </div>
    </app-header>
  </div>
</div>

<div
  class="section"
  [class.dark]="color && !scrolled"
  [class.header-out-of-view]="headerOutOfView"
  [class.scrolled]="scrolled"
  *onlyForScreens="['mobile', 'tablet']"
>
  <app-header [bigish]="true" class="fixed">
    <a class="logo-el" [routerLink]="'/'">
      <img src="/assets/picflow-icon.svg" alt="" width="32" height="32" />
      <span>Picflow</span>
    </a>
    <div class="spacer"></div>

    <div class="header-buttons mobile-header-buttons">
      <ng-container *ngTemplateOutlet="ctaButtons"></ng-container>

      <button
        appButton
        shape="round"
        name="mobile-menu"
        location="website-header"
        aria-label="mobile menu"
        [iconButton]="true"
        color="hard-simple"
        (click)="openMobileMenu()"
        height="1"
        *ngIf="!hideNav"
      >
        <app-svg src="/assets/icons/menu-burger.svg"></app-svg>
        <div class="button-hitbox-extender"></div>
      </button>
    </div>
  </app-header>

  <div class="header-shadow"></div>
</div>

<ng-template #ctaButtons>
  <ng-container *ngIf="!customCta">
    <div *onlyForScreens="['desktop']" class="flex">
      <ng-container *ngIf="!loggedIn">
        <a
          [routerLink]="'/auth/login'"
          appButton
          shape="round"
          name="login"
          location="website-header"
          weight="bold"
          color="simple-gray"
          *ngIf="!hideNav"
        >
          Log in
        </a>
        <a
          [routerLink]="'/auth/signup'"
          appButton
          shape="round"
          name="signup"
          location="website-header"
          color="primary"
          weight="bold"
          spacing="3"
        >
          Try for Free
        </a>
      </ng-container>
      <a
        [routerLink]="'/auth/login'"
        appButton
        shape="round"
        name="dashboard"
        location="website-header"
        weight="bold"
        color="primary"
        [hasIcon]="true"
        *ngIf="loggedIn"
      >
        <span>Dashboard</span>
        <app-svg src="/assets/icons/chevron-right.svg"></app-svg>
      </a>
    </div>

    <div *onlyForScreens="['mobile', 'tablet']">
      <a
        [routerLink]="'/auth/signup'"
        appButton
        shape="round"
        name="signup"
        location="website-header"
        color="primary"
        weight="bold"
        class="above-other-hitboxes"
        height="1"
        size="1"
      >
        Try for Free
      </a>
    </div>
  </ng-container>

  <ng-container *ngIf="customCta === 'contact'">
    <div class="custom-header-cta" *onlyForScreens="['desktop', 'tablet']">
      <span>Need Help?</span>
      <button
        appButton
        name="contact-us"
        location="conversion-template"
        shape="round"
        spacing="3"
        weight="bold"
        (click)="openIntercom()"
      >
        <span>Contact Us</span>
      </button>
    </div>
  </ng-container>
</ng-template>
